import { render } from "./SendAutuacao.vue?vue&type=template&id=f9ba7dfe"
import script from "./SendAutuacao.vue?vue&type=script&lang=js"
export * from "./SendAutuacao.vue?vue&type=script&lang=js"

import "./styles.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__